export default "__VITE_ASSET__Dcyqvx8v__"